import { render, staticRenderFns } from "./WaveSpecialties.vue?vue&type=template&id=fcdcb7e8&"
import script from "./WaveSpecialties.vue?vue&type=script&lang=js&"
export * from "./WaveSpecialties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports